import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Crown, Zap } from 'lucide-react';

const UpgradeModal = ({ open, onClose, errorData }) => {
  const navigate = useNavigate();

  const getMessage = () => {
    if (!errorData) return 'You have reached your plan limit.';
    
    if (typeof errorData === 'string') return errorData;
    
    return errorData.message || 'You have reached your plan limit. Upgrade to Pro for full access.';
  };

  const handleUpgrade = () => {
    onClose();
    navigate('/pricing');
  };

  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 rounded-full bg-gradient-to-r from-purple-100 to-cyan-100">
              <Crown className="w-8 h-8 text-purple-600" />
            </div>
          </div>
          <AlertDialogTitle className="text-center text-xl">
            Upgrade to Pro
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            {getMessage()}
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        <div className="my-4 p-4 bg-gradient-to-r from-purple-50 to-cyan-50 rounded-lg border border-purple-200">
          <div className="flex items-center gap-2 text-purple-700 font-semibold mb-2">
            <Zap className="w-4 h-4" />
            Pro Plan Benefits
          </div>
          <ul className="text-sm text-slate-600 space-y-1">
            <li>• 10,000 posts per session</li>
            <li>• Unlimited daily refreshes</li>
            <li>• Delete up to 500 posts at once</li>
            <li>• Full sorting & filtering</li>
          </ul>
        </div>
        
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>
            Maybe Later
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleUpgrade}
            className="bg-gradient-to-r from-purple-600 to-cyan-600 hover:from-purple-700 hover:to-cyan-700"
          >
            Upgrade Now - $9.99/mo
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default UpgradeModal;
